import { DeletePatientPayload } from 'pages/AdminPortal/types';
import { chiefAdminUrls } from 'utils/apiUrls';
import { HttpType } from 'utils/http';

const deletePatient = (method: HttpType['post'], body: DeletePatientPayload) => method(chiefAdminUrls.deletePatient.apiUrls().delete, body);

export default deletePatient;
